<script>
import { startOfToday, getYear, startOfYear, endOfYear, format } from 'date-fns'
import { REPORTS_LABEL, COLOR_CLASS } from '@reports/constant'
import _ from 'lodash'

export default {
  data() {
    return {
      reportsLabel: REPORTS_LABEL,
      allColorClass: COLOR_CLASS,
      dataSettings: [],
    }
  },
  methods: {
    addDataPoints(dateRange) {
      const newDateRange = Object.assign(
        {
          desc: `${format(new Date(dateRange.from), 'M/d/yyyy')} - ${format(
            new Date(dateRange.to),
            'M/d/yyyy'
          )}`,
          colorClass: this.allColorClass[this.dataSettings.length],
        },
        dateRange
      )
      this.fetchData(newDateRange)
    },
    initLastTwoYearsData() {
      const lastYear = getYear(new Date()) - 1
      const DATE_RANGE = [
        {
          from: startOfYear(new Date()),
          to: startOfToday(),
          desc: 'This Year',
          colorClass: 'bg-blue-light',
        },
        {
          from: startOfYear(new Date(lastYear, 10, 1)),
          to: endOfYear(new Date(lastYear, 10, 1)),
          desc: 'Last Year',
          colorClass: 'bg-green-300',
        },
      ]
      DATE_RANGE.forEach((range) => this.fetchData(range))
    },
    // generate bar max value
    getMaxLength(arr) {
      if (!arr.length) {
        return ''
      }
      const sum = arr.reduce((acc, cur) => {
        let curNum = cur
        if ((cur + '').indexOf(',') > -1) {
          curNum = cur.replace(',', '')
        }
        return +acc + +curNum
      }, 0)

      return Math.ceil((sum / 5) * 6)
    },
    getProgressbar(num, arr) {
      let curNum = +num
      if ((num + '').indexOf(',') > -1) {
        curNum = +num.replace(',', '')
      }
      const width =
        Math.ceil((curNum / this.getMaxLength(arr)) * 200 * 100) / 100
      return width < 1 ? 1 : width
    },
    sortingList(arr, key) {
      const newArr = _.sortBy(arr, [key])
      return newArr
    },
    exportDataFunc(csvString, fileName) {
      if (window.navigator.msSaveOrOpenBlob) {
        // IE
        const blob = new Blob([csvString])
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        const a = document.createElement('a')
        a.href = 'data:attachment/csv,' + encodeURIComponent(csvString)
        a.target = '_blank'
        a.download = fileName
        document.body.appendChild(a)
        a.click()
        setTimeout(() => a.remove(), 2000)
      }
    },
  },
}
</script>
